import request from '../utils/request';
import {List as response} from "ant-design-vue";
const baseTestURL = 'http://127.0.0.1:8082/user/';
// const BASE_URL = "http://154.8.219.40:8082/user/";



// GetToken
export function getToken(data) {
  return request({ url: process.env.VUE_APP_URL_MAIN_SERVICE_USER + `/get_token/`, method: 'post', data }, false)
}

// RefreshToken
export function refreshToken(data) {
  return request({ url: process.env.VUE_APP_URL_MAIN_SERVICE_USER + `/refresh_token/`, method: 'post', data })
}

// GetInfo
export function getInfo(params) {
  return request({ url: process.env.VUE_APP_URL_MAIN_SERVICE_USER + `/info/`, method: 'get', params })
}

// SetPassword
export function setPassword(data) {
  return request({ url: process.env.VUE_APP_URL_MAIN_SERVICE_USER + `/set_password/`, method: 'post', data })
}

// 常用功能
export function getCommonFunctions(params) {
  return request({ url: process.env.VUE_APP_URL_MAIN_SERVICE_USER + `/common_functions/`, method: 'get', params })
}

// 设置常用功能
export function setCommonFunctions(data) {
  return request({ url: process.env.VUE_APP_URL_MAIN_SERVICE_USER + `/set_common_functions/`, method: 'post', data })
}

// reg
export function reg(data) {
  return request({ url: process.env.VUE_APP_URL_MAIN_SERVICE_USER + `/register`, method: 'post', data, timeout: 20000  }, false)
}

export function sendemail(data) {
  return request({ url: process.env.VUE_APP_URL_MAIN_SERVICE_USER + `/sendemail?email=`+data, method : 'get'})
}

export function login(data) {
 /* const token = response.data;
  console.log(token);
  localStorage.setItem('token', token);*/
  return request({ url: process.env.VUE_APP_URL_MAIN_SERVICE_USER +'/'+data.username+'/'+data.password, method: 'get' }, false)
}



